import { memo } from 'react'
import { ClusterProperties } from 'supercluster'
import { AdvancedMarker, AdvancedMarkerAnchorPoint } from '@vis.gl/react-google-maps'
import { Box } from '@/components/Layout'
import Marker, { MARKER_TYPE, MarkerProps, markerZindex } from '../Marker'
import { clusterStyles as styles } from './Cluster.style'
import { useClusterController } from './Cluster.controller'
import { ClusterProps } from './Cluster.types'

const Cluster = ({
  locations,
  selectedMarker,
  onMarkerClose,
  onMarkerClick,
  autoFitPinZoom = false,
  circleRadiusInMiles,
  centerLocation,
}: ClusterProps) => {
  const { clusters, handleMarkerOnClick, handleClusterClick } = useClusterController({
    locations,
    selectedMarker,
    onMarkerClose,
    onMarkerClick,
    autoFitPinZoom,
    circleRadiusInMiles,
    centerLocation,
  })

  return clusters.map((feature, index) => {
    const [lng, lat] = feature.geometry.coordinates

    const clusterProperties = feature.properties as ClusterProperties
    const isCluster: boolean = clusterProperties.cluster

    const properties = feature.properties as MarkerProps

    if (isCluster)
      return (
        <AdvancedMarker
          key={feature.id}
          zIndex={index + 1}
          position={{ lat, lng }}
          anchorPoint={AdvancedMarkerAnchorPoint.CENTER}
          onClick={() => handleClusterClick(clusterProperties.cluster_id)}>
          <Box sx={styles.marker}>{clusterProperties.point_count_abbreviated}</Box>
        </AdvancedMarker>
      )

    return (
      <AdvancedMarker
        key={feature.id}
        position={{ lat, lng }}
        zIndex={
          properties.type !== MARKER_TYPE.HOTEL_PRICE
            ? clusters.length + markerZindex[properties.type]
            : index + 1
        }
        anchorPoint={AdvancedMarkerAnchorPoint.CENTER}
        onClick={() => handleMarkerOnClick(properties)}>
        <Marker active={selectedMarker?.key === properties.key} marker={properties} />
      </AdvancedMarker>
    )
  })
}

export default memo(Cluster)
